import { Flex, type FlexProps } from '@chakra-ui/react'
import type { FC, ReactNode } from 'react'

type Props = { children?: ReactNode }

export const MagicBoxHeader: FC<Props & FlexProps> = ({
  children,
  ...restProps
}) => {
  return (
    <Flex
      py="2"
      px="4"
      width="100%"
      justifyContent="space-between"
      borderBottom="1px solid"
      borderColor="greys.200"
      flexDir="column"
      {...restProps}
    >
      {children}
    </Flex>
  )
}
